module.exports = __webpack_public_path__ + "static/media/light-green-flag.f3fa57b1.svg";